import { createApp } from 'vue';
import App from './DialogsMountpoint.vue';
import FontAwesomePlugin from '@/plugins/fontawesome';
import {registerSingleton} from "@/services/GlobalContext";

class DialogManager{
    constructor() {
        const app = createApp(App);

        let mountPoint = document.createElement("div");
        mountPoint.id = "dialogManager";
        document.body.prepend(mountPoint)
        app.use(FontAwesomePlugin);

        setTimeout(() => {
            app.mount('#dialogManager');
        });
        this.app = app;
        /** @type {import('./DialogsMountpoint.vue').default} */
        this.mountpointInstance = null;
    }

    setMountpointInstance(i){
        this.mountpointInstance = i;
    }

    async textInput(dialogTitle, dialogInputLabel, validatorFunction=null, dialogInputPlaceholder=""){
        let that = this;
        return new Promise((resolve) => {
            that.mountpointInstance.exposed.textInput.value.setupDialog(dialogTitle, dialogInputLabel, resolve, validatorFunction, dialogInputPlaceholder);
        });
    }

    async confirmation(dialogTitle, dialogBody){
        let that = this;
        return new Promise((resolve) => {
            that.mountpointInstance.exposed.confirmation.value.setupDialog(dialogTitle, dialogBody, resolve);
        });
    }

    async createAccountAd(dialogTitle, dialogBody){
        let that = this;
        return new Promise((resolve) => {
            that.mountpointInstance.exposed.createAccount.value.setupDialog(dialogTitle, dialogBody, resolve);
        });
    }

    async info(dialogTitle, dialogBody){
        let that = this;
        return new Promise((resolve) => {
            that.mountpointInstance.exposed.info.value.setupDialog(dialogTitle, dialogBody, resolve);
        });
    }
}

/**
 * @type {DialogManager}
 */
let dialogManager = registerSingleton('DialogManager', () => new DialogManager());

export default dialogManager;
